// Console-based logging service

export const getLogInfo = () => {
  return {
    name: 'panelist_webapp_frontend',
  };
};

export const getLogContext = (additionalInfo: Record<string, any> = {}) => {
  return {
    ...additionalInfo,
    userAgent: navigator.userAgent,
    environment: process.env.NODE_ENV,
  };
};

export const log = {
  /* eslint-disable no-console */
  info: (
    message: string,
    eventId: number,
    additionalInfo?: Record<string, any>
  ) => {
    console.log(message, {
      eventId,
      ...getLogInfo(),
      context: getLogContext(additionalInfo),
    });
  },
  error: (
    message: string,
    eventId: number,
    error: any,
    additionalInfo?: Record<string, any>
  ) => {
    console.error(message, {
      eventId,
      error,
      ...getLogInfo(),
      context: getLogContext(additionalInfo),
    });
  },
  /* eslint-enable no-console */
};
